/**
 * Archivo para definir los permisos para el paquete de CALS
 */
import { AbilityBuilder, Ability } from "@casl/ability";
import * as abilityConstants from "./ability-constants";

const ability = function (user) {
  if (user) {
    const { can, rules, cannot } = new AbilityBuilder(Ability);
    // can("manage", "all");
    // can("read", "all");

    cannot("manage", "all");
    cannot("read", "all");

    // abilityConstants.ALL_ABILITIES.forEach((a) => {
    //   if (user.getPermission(a)) {
    //     if (a.indexOf("MANAGE_") !== -1) {
    //       can("manage", a);
    //     } else {
    //       can("read", a);
    //     }
    //   }
    // });

    const superAdminAbility = () => {
      can("manage", "all");
      can("read", "all");
    };

    superAdminAbility();
    return new Ability(rules);
  }
  return new Ability();
};

export default ability;
